import {
  Box,
  Button,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  CardMedia,
} from "@mui/material";
import { useQuery } from "react-query";
import { Instance } from "../../types/whatsapp";
import { getStatusInstance } from "../../services/whatsapp";
import { useToast } from "../../hooks/useToast";

interface QRCodeDialogProps {
  open: boolean;
  instance: Instance;
  close: () => void;
}

export function QRCodeDialog(props: QRCodeDialogProps) {
  const { open, close, instance } = props;
  const toast = useToast();

  const handleClose = () => close();

  const qrcode = useQuery(
    ["qrcode", instance?.id],
    () => {
      return getStatusInstance(instance.id!);
    },
    {
      enabled: Boolean(instance) && open,
      refetchInterval: 45000,
    }
  );

  const QrCode = () => {
    if (qrcode.data && qrcode.data.qr) {
      return (
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CardMedia
            image={qrcode.data.qr}
            title="QR Code"
            style={{ height: 200, width: 200 }}
          />
        </Box>
      );
    } else {
      if (qrcode.data?.connected) {
        toast.show("WhatsApp conectado com sucesso!", { severity: "success" });
        handleClose();
        return <></>;
      } else {
        return (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              padding: 30,
            }}
          >
            <Typography>
              Estamos organizando a instância para uma conexão mais segura. 🔒🌐
            </Typography>
            <Typography mt={2} variant="body2">
              Aguarde alguns instantes até que o qrcode apareça. ⌛🧘
            </Typography>
            <LinearProgress
              variant="indeterminate"
              sx={{ mt: 2, width: "100%" }}
            />
          </Box>
        );
      }
    }
  };

  return (
    <Dialog open={open} maxWidth="md">
      <Box sx={{ p: 4 }}>
        <DialogTitle sx={{ p: "0 12px" }} fontSize="1.5rem">
          Vincular número de Whatsapp
          <Box display="flex" flexDirection="column" gap={1} mt={1}>
            <Typography>
              Para vincular seu número, siga as instruções abaixo:
            </Typography>
            <Typography>1. Abra o seu Whatapp no celular</Typography>
            <Typography>
              2. Vá em ”Menu” ou ”Configurações” e selecione <b>Whatsapp Web</b>
            </Typography>
            <Typography>
              3. Aponte a câmera do seu celular para o código abaixo
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ p: "32px 0" }}>
            <Divider />
            <Box>
              <QrCode />
            </Box>
            <Divider />
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ p: 0, display: "flex", justifyContent: "space-between" }}
        >
          <Button autoFocus color="inherit" onClick={close}>
            Cancelar
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
